module.exports = __webpack_public_path__ + "img/Group 97839.770085c3.png";